export class Category {
  constructor(public id: number = 0,
              public name: string = '',
              public default_task_color: string = '', // tslint:disable-line
              public board_id: number = 0) { // tslint:disable-line
  }
}

